import React from 'react';
import { PropTypes } from 'prop-types';
import { useLabels } from 'wsm-common-data';
import { setClassNames } from 'ddc-classnames-js';

const LocationMapLinks = ({ mapUrl, fullAddress }) => {
	const labels = useLabels();
	const locationMapClasses = setClassNames([
		'location-map',
		'd-flex',
		'border-top',
		'py-4',
		'border-bottom'
	]);

	return (
		<div className={locationMapClasses}>
			<a
				className="pl-3"
				href={mapUrl}
				target="_blank"
				rel="noopener noreferrer"
				aria-label={`View map of ${fullAddress} in new tab`}
			>
				{labels.get('VIEW_A_MAP')}
			</a>
			<div className="ml-auto d-flex align-items-center justify-content-center text-primary">
				<a
					href={mapUrl}
					target="_blank"
					rel="noopener noreferrer"
					aria-label={`View map of ${fullAddress} in new tab`}
				>
					<i
						className="ddc-icon ddc-icon-chevron-right ddc-icon-size-medium"
						aria-hidden="true"
					/>
				</a>
			</div>
		</div>
	);
};

LocationMapLinks.propTypes = {
	mapUrl: PropTypes.string.isRequired,
	fullAddress: PropTypes.string.isRequired
};

export default LocationMapLinks;
